import React from 'react';
import { ShieldCheck, Award, Wrench, Building2, MapPin } from 'lucide-react';
function StarRow({
  size = 'w-4 h-4'
}: {
  size?: string;
}) {
  return <div className="flex items-center gap-0.5 text-amber-500" aria-hidden="true" data-id="element-287">
      {[0, 1, 2, 3, 4].map(i => <svg key={i} className={`${size} fill-current`} viewBox="0 0 20 20" data-id="element-288">
          <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9z" data-id="element-289" />
        </svg>)}
    </div>;
}
export function Reviews() {
  const reviews = [{
    quote: '[Paste real customer review here.]',
    name: '[Customer Name]',
    city: '[City]',
    label: 'Commercial Client'
  }, {
    quote: '[Paste real customer review here.]',
    name: '[Customer Name]',
    city: '[City]',
    label: 'Property Manager'
  }, {
    quote: '[Paste real customer review here.]',
    name: '[Customer Name]',
    city: '[City]',
    label: 'General Contractor'
  }];
  const proofItems = [{
    icon: <Building2 className="w-4 h-4 text-primary-600" data-id="element-290" />,
    label: 'Storefront Glass Specialists'
  }, {
    icon: <Wrench className="w-4 h-4 text-primary-600" data-id="element-291" />,
    label: 'Fabrication & Installation'
  }, {
    icon: <Award className="w-4 h-4 text-primary-600" data-id="element-292" />,
    label: 'Family-Owned Since 2000'
  }, {
    icon: <MapPin className="w-4 h-4 text-primary-600" data-id="element-293" />,
    label: 'Howell, Ann Arbor & Novi'
  }, {
    icon: <ShieldCheck className="w-4 h-4 text-primary-600" data-id="element-294" />,
    label: 'Warranty-Backed Work'
  }];
  return <section className="py-20 bg-cream-50 border-t border-neutral-200" data-id="element-295">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-297">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary-50 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4 font-sans" data-id="element-298">
            Customer Reviews
          </div>
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900 mb-4" data-id="element-299">
            What Customers Say About Kosin's Glass
          </h2>
          <p className="text-lg text-neutral-600 font-sans" data-id="element-300">
            Businesses, builders and property managers count on Kosin's Glass
            for storefront glass, commercial windows, office glass walls and
            contract glazing across Southeast Michigan.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-301">
          {reviews.map((r, idx) => <article key={idx} className="bg-white rounded-md p-6 border border-neutral-200 shadow-sm flex flex-col" aria-label={`5-star customer review from ${r.label}`} data-id="element-302">
              <StarRow data-id="element-303" />
              <span className="sr-only" data-id="element-304">5-star review</span>
              <blockquote className="mt-4 mb-5 flex-grow" data-id="element-305">
                <p className="text-neutral-700 italic leading-relaxed font-sans" data-id="element-306">
                  "{r.quote}"
                </p>
              </blockquote>
              <footer className="border-t border-neutral-100 pt-4 font-sans" data-id="element-307">
                <p className="font-semibold text-neutral-900 text-sm" data-id="element-308">
                  {r.name}
                </p>
                <p className="text-neutral-500 text-xs" data-id="element-309">{r.city}</p>
                <p className="text-primary-600 text-[11px] font-semibold uppercase tracking-wider mt-1.5" data-id="element-310">
                  {r.label}
                </p>
              </footer>
            </article>)}
        </div>

        {/* Proof-stat strip */}
        <div className="bg-white border border-neutral-200 rounded-md shadow-sm py-5 px-6" data-id="element-311">
          <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-3" data-id="element-312">
            {proofItems.map((item, idx) => <div key={idx} className="flex items-center gap-2 text-sm font-semibold text-neutral-700 font-sans" data-id="element-313">
                {item.icon}
                <span data-id="element-314">{item.label}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}